module.exports = __webpack_public_path__ + "img/hero-phone.1acd9008.svg";